module.exports = __webpack_public_path__ + "img/locked.e5caa75.png";